module.exports = __webpack_public_path__ + "static/media/frischeparadies-thomueller.356c9f9e.png";